import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  realm: "gst",
  url: "https://auth.gstinc.link/auth",
  clientId: "react-app",
})

export default keycloak
